import React from 'react'
import movieHasNoLength from '../functions/movieHasNoLength'
import { TranslationCont } from '../General/TranslationCont'

const MovieLengthAccess = ({length}) => {
    if(movieHasNoLength(length)) {
        return ''
    }

    return (
        <>
            <dt><TranslationCont id='movieLength' after=':'>Filmlänge</TranslationCont></dt>
            <dd>{length} <TranslationCont id="movieLengthUnit">Minuten</TranslationCont></dd>
        </>
    )
}

export default MovieLengthAccess